<template>
  <div>
    <div class="web">
      <el-carousel
        indicator-position="none"
        :autoplay="true"
        arrow="always"
        height="11.89rem"
      >
        <el-carousel-item>
          <div class="swpiperItem" style="background-color: #f6f4f1">
            <div class="top">
              <div class="top-left">
                <div class="top-left-one">
                  <span>Personalized</span>
                  <span>Dietary</span>
                  <span>Supplements</span>
                </div>
                <div class="top-left-two">
                  个性匹配&nbsp;&nbsp;&nbsp;&nbsp;因人而异的专属营养
                </div>
              </div>
              <div class="top-right">
                <img class="top-right-image" :src="indexTopBanner" alt="" />
                <div class="top-right-text">
                  <span>· 美国制造</span>
                  <span>· 保税区直邮</span>
                  <span>· 30 袋/盒</span>
                </div>
              </div>
            </div>
          </div>
        </el-carousel-item>
        <el-carousel-item>
          <div class="swpiperItem" style="background-color: #fbfbf8">
            <div class="top">
              <div class="top-left">
                <div class="top-left-one">
                  <span>5-Day </span>
                  <span> Care Packs</span>
                </div>
                <div
                  class="top-left-two"
                  style="text-align: left; line-height: 0.7rem"
                >
                  应急营养包系列<br />
                  各种临时场景化需求的便捷营养方案
                </div>
              </div>
              <div class="top-right top-right2">
                <img
                  class="top-right-image top-right-image2"
                  src="https://cdn-file.xiaojudai.cn/web/dist/indexBanner/banner3.png"
                  alt=""
                />
              </div>
            </div>
          </div>
        </el-carousel-item>
        <el-carousel-item>
          <div class="swpiperItem" style="background-color: #fff">
            <div class="top">
              <div class="top-left">
                <div class="top-left-one">
                  <span>Sichuan Men's </span>
                  <span>Volleyball Team</span>
                </div>
                <div class="top-left-two">四川男排冠名合作营养品牌</div>
              </div>
              <div class="top-right top-right3">
                <img
                  class="top-right-image top-right-image2"
                  src="https://cdn-file.xiaojudai.cn/web/dist/indexBanner/banner2.png"
                  alt=""
                />
              </div>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
      <div class="step-module">
        <div class="step-module-title">Wellness Journey Starts Simple</div>
        <div class="step-module-title-ch">3步定制 不止营养补剂</div>
        <div class="stepItemBox">
          <div class="item">
            <div class="tag">STEP 1</div>

            <img
              src="https://cdn-file.xiaojudai.cn/web/dist/customer/step1.png"
              alt=""
              class="pic"
            />
            <img
              src="https://cdn-file.xiaojudai.cn/web/dist/customer/step1_1440.png"
              alt=""
              class="pic_1440"
            />
            <div class="des1">3分钟AI营养测评</div>
            <div class="des2">
              中美权威营养测评，从13个需求、8个维度全面评估身体状况
            </div>
          </div>
          <div class="item">
            <div class="tag">STEP 2</div>

            <img
              src="https://cdn-file.xiaojudai.cn/web/dist/customer/step2.png"
              alt=""
              class="pic"
            />
            <img
              src="https://cdn-file.xiaojudai.cn/web/dist/customer/step2_1440.png"
              alt=""
              class="pic_1440"
            />
            <div class="des1">获取精准补剂方案</div>
            <div class="des2">
              超1,000,000+营养数据支持，大数据算法，生成100%匹配需求的健康报告
            </div>
          </div>
          <div class="item">
            <div class="tag">STEP 3</div>

            <img
              src="https://cdn-file.xiaojudai.cn/web/dist/customer/step3.png"
              alt=""
              class="pic"
            />
            <img
              src="https://cdn-file.xiaojudai.cn/web/dist/customer/step3_1440.png"
              alt=""
              class="pic_1440"
            />
            <div class="des1">定制专属每日一袋</div>
            <div class="des2">保税仓快速发货，顺丰直邮，每日轻松补充</div>
          </div>
        </div>
      </div>
      <!-- <div
        class="quality-module"
        :style="{ height: goodsList.length > 30 ? '48rem' : '' }"
      > -->
      <div class="quality-module">
        <div class="quality-module-title">Quality Is Important</div>
        <div class="quality-module-description">
          除了AI定制，你更应该关注补剂本身。<br />
          全线补剂配方由NHRC纽约营养科学团队根据国人需求进行研发，涵盖15项健康分类。
        </div>
        <div class="quality-demand-tags">
          <div class="quality-tag" v-for="(item, i) in demandTags" :key="i">
            {{ item }}
          </div>
        </div>
        <div class="goods-wrap">
          <div
            class="goods-items"
            :style="{
              transform: `translateX(-${
                scrollLeft == 0 ? scrollLeft : scrollLeft + 4.5
              }rem)`,
            }"
            @mouseenter="showArrow"
            @mouseleave="hiddeArrow"
          >
            <div
              class="goods-item"
              v-for="(item, i) in goodsList"
              :key="i"
              :style="{ backgroundImage: `url(${item.web_img})` }"
            >
              <img class="goods-item-image" :src="item.broadside_img_url" />
              <div class="demand">
                <div
                  class="tag"
                  v-for="(tagItem, i) in item.goods_cat_title"
                  :key="i"
                  :style="{
                    background: `${demandColorFormat[tagItem].bgColor}`,
                  }"
                >
                  {{ tagItem }}
                </div>
              </div>
              <div class="goods-item-info">
                <div class="goods-name">{{ item.goods_name }}</div>
                <div class="goods-name-en">{{ item.sale_eng_name }}</div>
                <div class="goods-point">
                  <div
                    class="goods-point-item"
                    v-for="(pointItem, i) in item.web_sale_list"
                    :key="i"
                  >
                    {{ pointItem.title }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="arrow-left"
            @mouseenter="showArrow"
            @click="scrollCardsLeft"
            :style="{ opacity: scrollLeft > 0 ? '1' : '0' }"
          ></div>
          <div
            class="arrow-right"
            @mouseenter="showArrow"
            @click="scrollCardsRight"
            :style="{ opacity: isArrowVisible ? '1' : '0' }"
          ></div>
        </div>
        <div class="promise">
          <div class="promise-wrap">
            <div class="promise-title">营养成分<br />100%透明承诺</div>
            <div class="promise-description">
              我们将每一款补剂配方向你如实公开，承诺100%透明展示。你所需要了解的配方信息都在这一张营养成分表上了，你所看见的就是你服用的！
            </div>
            <img class="promise-goods-img" :src="promiseGoods" />
            <img class="promise-tags-image" :src="promiseTags" alt="" />
          </div>
        </div>
      </div>
      <div class="guarantee-module">
        <div class="guarantee-left">
          <div class="guarantee-title">
            更高标准 层层把关<br />放心安全的品质保障
          </div>
          <div class="guarantee-items">
            <div
              class="guarantee-item"
              v-for="(item, i) in guaranteeList"
              :key="i"
            >
              <img class="guarantee-item-icon" :src="item.icon" alt="" />
              <div class="guarantee-item-right">
                <div class="guarantee-item-right-title">{{ item.title }}</div>
                <div class="guarantee-item-right-description">
                  {{ item.description }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <img class="guarantee-right" :src="guaranteeImage" />
      </div>
      <!-- 搭配案例 -->
      <div class="dapeiExample_pc">
        <div class="mainTitle">Customer Snapshots</div>
        <div class="subTitle">搭配案例</div>
        <Example></Example>
      </div>
      <div class="bottom">
        <div class="bottom-title">NUTRIPACKS has been featured in</div>
        <img class="company-image" :src="companyImage" alt="" />
        <div class="bottom-banner-wrap">
          <img class="bottom-banner" :src="bottomBanner" alt="" />
          <div class="bottom-banner-right">
            <div class="bottom-banner-title">Starting a Healthy Life</div>
            <div class="bottom-banner-btn cursor" @click="toMake($event, 0)">
              Try NUTRIPACKS Now
              <img
                src="https://cdn-file.xiaojudai.cn/web/dist/arr_r_w_index.png"
                class="arrR"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mobile">
      <!-- Swiper 容器 -->
      <div class="swiper-container_m" style="">
        <div class="swiper-wrapper">
          <!-- 幻灯片内容 -->
          <div
            class="swiper-slide swiperItem swiperItem_bgHeight"
            style="
              background-image: url('https://cdn-file.xiaojudai.cn/web/dist/indexBanner/banner1_m_768.png');
              /* background-size: 100% 7.27rem; */
              background-color: #f6f4f1;
            "
          >
            <div class="top-tags-text">
              <span>· 美国制造</span>
              <span>· 保税区直邮</span>
              <span>· 30 袋/盒</span>
            </div>
            <div class="top-title">Personalized Dietary <br />Supplements</div>
            <div class="top-title-ch">
              个性匹配&nbsp;&nbsp;&nbsp;因人而异的专属营养
            </div>
          </div>
          <div
            class="swiper-slide swiperItem swiperItem_pb"
            style="
              background-image: url('https://cdn-file.xiaojudai.cn/web/dist/indexBanner/banner3_m_768.png');
            "
          >
            <div class="top-title">5-Day Care Packs</div>
            <div class="top-title-ch" style="line-height: 0.53rem">
              应急营养包系列<br />
              各种临时场景化需求的便捷营养方案
            </div>
          </div>
          <div
            class="swiper-slide swiperItem swiperItem_pb"
            style="
              background-image: url('https://cdn-file.xiaojudai.cn/web/dist/indexBanner/banner2_m_768.png');
            "
          >
            <div class="top-title">Sichuan Men's <br />Volleyball Team</div>
            <div class="top-title-ch">四川男排冠名合作营养品牌</div>
          </div>
        </div>
        <div class="swiper-pagination"></div>
      </div>
      <div class="step-module">
        <div class="step-module-title">
          Wellness Journey <br />Starts Simple
        </div>
        <div class="step-module-title-ch">
          3步定制&nbsp;&nbsp;&nbsp;不止营养补剂
        </div>
        <div class="step-items">
          <div class="step-item-wrap" v-for="(item, i) in stepList" :key="i">
            <div class="step-item-tips">STEP&nbsp;{{ i + 1 }}</div>
            <div class="step-item">
              <img :src="item.image" alt="" />
              <div class="step-item-title">{{ item.title }}</div>
              <div class="step-item-description">{{ item.description }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="quality-module">
        <div class="quality-title">Quality Is Important</div>
        <div class="quality-title-ch">
          除了AI定制，你更应该关注补剂本身。<br />全线补剂配方由NHRC纽约营养科学团队根据国人需求进行研发，涵盖15项健康分类。
        </div>
        <div class="quality-demand-tags">
          <!-- <div class="quality-tag" v-for="(item, i) in demandTags" :key="i" :style="{'margin-right':item=='肝脏'? 0:''}"> -->
          <div class="quality-tag" v-for="(item, i) in demandTags" :key="i">
            {{ item }}
          </div>
        </div>
        <div class="goods-wrap">
          <div
            class="goods-items"
            :style="{ transform: `translateX(-${scrollLeft}rem)` }"
          >
            <div
              class="goods-item"
              v-for="(item, i) in goodsList"
              :key="i"
              :style="{ backgroundImage: `url(${item.web_img})` }"
            >
              <img class="goods-item-image" :src="item.broadside_img_url" />
              <div class="demand">
                <div
                  class="tag"
                  v-for="(tagItem, i) in item.goods_cat_title"
                  :key="i"
                  :style="{
                    background: `${demandColorFormat[tagItem].bgColor}`,
                  }"
                >
                  {{ tagItem }}
                </div>
              </div>
              <div class="goods-item-info">
                <div class="goods-name">{{ item.goods_name }}</div>
                <div class="goods-name-en">{{ item.sale_eng_name }}</div>
                <div class="goods-point">
                  <div
                    class="goods-point-item"
                    v-for="(pointItem, i) in item.web_sale_list"
                    :key="i"
                  >
                    {{ pointItem.title }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="promise">
          <div class="promise-title">营养成分&nbsp;&nbsp;100%透明承诺</div>
          <div class="promise-description">
            我们将每一款补剂配方向你如实公开，承诺100%透明展示。<br />你所需要了解的配方信息都在这一张营养成分表上了，<br />你所看见的就是你服用的！
          </div>
          <div class="promise-description_768">
            我们将每一款补剂配方向你如实公开，承诺100%透明展示。你所需要了解的配方信息都在这一张<br />营养成分表上了，你所看见的就是你服用的！
          </div>
          <div class="promise-wrap">
            <img class="promise-goods-img" :src="promiseGoods" />
            <img class="promise-tags-image" :src="promiseTags" alt="" />
          </div>
        </div>
      </div>
      <div class="guarantee-module">
        <div class="guarantee-top">
          <div class="guarantee-title">
            更高标准 层层把关<br />放心安全的品质保障
          </div>
          <div class="guarantee-items">
            <div
              class="guarantee-item"
              v-for="(item, i) in guaranteeList"
              :key="i"
            >
              <img class="guarantee-item-icon" :src="item.icon" alt="" />
              <div class="guarantee-item-right">
                <div class="guarantee-item-right-title">{{ item.title }}</div>
                <div class="guarantee-item-right-description">
                  {{ item.description }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="guarantee-bottom"
          style="
            background-image: url('https://cdn-file.xiaojudai.cn/web/dist/guarantee-banner-h5-pc.png');
          "
        ></div>
        <img
          class="guarantee-bottom_768"
          src="https://cdn-file.xiaojudai.cn/web/dist/guarantee-banner-h5-pc_768.png"
        />
        <!-- <img class="guarantee-bottom" :src="guaranteeH5Image" /> -->
      </div>
      <div class="customer-module">
        <div class="customer-title">Customer Snapshots</div>
        <div class="customer-title-ch">搭配案例</div>
        <div class="customer-wrap">
          <div
            class="customer-items"
            :style="{ transform: `translateX(-${customerScrollLeft}rem)` }"
          >
            <img
              class="customer-item"
              v-for="(item, i) in customerList"
              :key="i"
              :src="item"
            />
          </div>
        </div>
      </div>
      <div class="bottom">
        <div class="bottom-title">NUTRIPACKS has been featured in</div>
        <img class="company-image" :src="companyImageH5" alt="" />
        <div class="bottom-banner-wrap">
          <img class="bottom-banner" :src="bottomBanner" alt="" />
          <div class="bottom-banner-title">Starting a Healthy Life</div>
          <div class="bottom-banner-btn" @click="toMake($event, 0)">
            Try NUTRIPACKS Now
            <img
              src="https://cdn-file.xiaojudai.cn/web/dist/arr_r_w_index.png"
              class="arrR"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- 定制弹窗 -->
    <CodePupop
      ref="myPupop"
      :position="position"
      :left="left"
      :top="top"
    ></CodePupop>
  </div>
</template>
<script>
if (navigator.userAgent.indexOf("AliApp") > -1) {
  document.writeln(
    '<script src="https://appx/web-view.min.js"' + ">" + "<" + "/" + "script>"
  );
}
</script>
<script>
// my.onMessage = function(e) {
//     console.log(e); // {'sendToWebView': '1'}
// 		alert('123')
//   }
</script>
<script>
import Swiper from "swiper";
import { md5 } from "../util/md5.js";
import CodePupop from "../components/codePupop.vue";
import Example from "../components/example.vue";

export default {
  name: "index",
  components: { CodePupop, Example },
  data: () => ({
    page: "home",
    swiperOption: {
      autoplay: {
        delay: 2000,
        disableOnInteraction: true,
      },
      loop: true,
    },
    publicwww: "https://nutripacks-static.oss-cn-shenzhen.aliyuncs.com/",
    publicurl:
      "https://nutripacks-static.oss-cn-shenzhen.aliyuncs.com/static/common/images/official-website/imgs/",
    stepList: [
      {
        image:
          "https://nutripacks-static.oss-cn-shenzhen.aliyuncs.com/static/official_website/index/index-step-1.png",
        title: "3分钟AI营养测评",
        description: "中美权威营养测评，从13个需求、8个维度全面评估身体状况",
      },
      {
        image:
          "https://nutripacks-static.oss-cn-shenzhen.aliyuncs.com/static/official_website/index/index-step-2.png",
        title: "获取精准补剂方案",
        description:
          "超1,000,000+营养数据支持，大数据算法，生成100%匹配需求的健康报告",
      },
      {
        image:
          "https://nutripacks-static.oss-cn-shenzhen.aliyuncs.com/static/official_website/index/index-step-3.png",
        title: "定制专属每日一袋",
        description: "保税仓快速发货，顺丰直邮，每日轻松补充",
      },
    ],
    demandTags: [
      "精力",
      "压力",
      "免疫",
      "皮肤",
      "眼睛",
      "骨骼",
      "关节",
      "肝脏",
      "头发头皮",
      "睡眠",
      "心血管",
      "大脑",
      "HPV",
      "孕期",
      "肠道",
    ],
    tagList: ["心血管", "大脑", "HPV", "免疫", "皮肤"],
    guaranteeList: [
      {
        icon: "https://nutripacks-static.oss-cn-shenzhen.aliyuncs.com/static/official_website/index/guarantee-icon-1.png",
        title: "超过 25 项专利和工艺应用",
        description:
          "从原料到辅料，从成分到工艺，我们打造长期服用安全性，更打造更高效的生物吸收利用率",
      },
      {
        icon: "https://nutripacks-static.oss-cn-shenzhen.aliyuncs.com/static/official_website/index/guarantee-icon-2.png",
        title: "中美 4 重安全检测 全链权威认证",
        description:
          "严格符合NSF GMP美国膳食营养补充剂最高认证标准；制造环境通过FDA注册并符合GMP要求",
      },
      {
        icon: "https://nutripacks-static.oss-cn-shenzhen.aliyuncs.com/static/official_website/index/guarantee-icon-3.png",
        title: "ISO 双认证自动化洁净分装",
        description:
          "每一颗补剂在美国生产，并空运至 NUTRIPACKS 双流保税区洁净分装中心，按照你的健康需求实时自动化分装",
      },
    ],
    isAlipay: navigator.userAgent.indexOf("AliApp") > -1 ? true : false,
    indexTopBanner:
      "https://nutripacks-static.oss-cn-shenzhen.aliyuncs.com/static/official_website/index/index-top-banner.png",
    qualityBackgroundIamge:
      "https://nutripacks-static.oss-cn-shenzhen.aliyuncs.com/static/official_website/index/quality-bg.png",
    goodsList: [], // 创建29个药信息的占位数组
    scrollLeft: 0,
    customerScrollLeft: 0,
    arrowRigit:
      "https://nutripacks-static.oss-cn-shenzhen.aliyuncs.com/static/official_website/index/arrow-right.png",
    arrowLeft:
      "https://nutripacks-static.oss-cn-shenzhen.aliyuncs.com/static/official_website/index/arrow-left.png",
    arrowRigitTwo:
      "https://nutripacks-static.oss-cn-shenzhen.aliyuncs.com/static/official_website/index/arrow-right-2.png",
    arrowLeftTwo:
      "https://nutripacks-static.oss-cn-shenzhen.aliyuncs.com/static/official_website/index/arrow-left-2.png",
    promiseGoods:
      "https://nutripacks-static.oss-cn-shenzhen.aliyuncs.com/static/official_website/index/promise-goods.png",
    promiseTags:
      "https://nutripacks-static.oss-cn-shenzhen.aliyuncs.com/static/official_website/index/promise-tags.png",
    guaranteeImage:
      "https://nutripacks-static.oss-cn-shenzhen.aliyuncs.com/static/official_website/index/guarantee-banner.png",
    // guaranteeH5Image:
    //   "https://nutripacks-static.oss-cn-shenzhen.aliyuncs.com/static/official_website/index/guarantee-banner-h5.png",
    //  guaranteeH5Image:
    // "https://cdn-file.xiaojudai.cn/web/dist/guarantee-banner-h5-m.png",
    guaranteeH5Image:
      "https://cdn-file.xiaojudai.cn/web/dist/guarantee-banner-h5-pc.png",
    companyImage:
      "https://nutripacks-static.oss-cn-shenzhen.aliyuncs.com/static/official_website/index/company.png",
    companyImageH5:
      "https://nutripacks-static.oss-cn-shenzhen.aliyuncs.com/static/official_website/index/company-h5.png",
    bottomBanner:
      "https://nutripacks-static.oss-cn-shenzhen.aliyuncs.com/static/official_website/index/bottom-banner.png",
    customerList: [],
    goodsInfoBgTest:
      "https://nutripacks-static.oss-cn-shenzhen.aliyuncs.com/static/official_website/index/goods-info-bg.png",
    goodsInfoImageTest:
      "https://nutripacks-static.oss-cn-shenzhen.aliyuncs.com/static/official_website/index/goods-info-image.png",
    demandColorFormat: {
      皮肤: {
        bgColor: "#EFE2E3",
        demand: "皮肤",
      },
      免疫: {
        bgColor: "#D4DADE",
        demand: "免疫",
      },
      心脏: {
        bgColor: "#E2C7C1",
        demand: "心脏",
      },
      心血管: {
        bgColor: "#E2C7C1",
        demand: "心血管",
      },
      精力: {
        bgColor: "#FAE4BE",
        demand: "精力",
      },
      精力肝脏: {
        bgColor: "#FAE4BE",
        demand: "精力肝脏",
      },
      压力: {
        bgColor: "#DEDED8",
        demand: "压力",
      },
      压力情绪: {
        bgColor: "#DEDED8",
        demand: "压力情绪",
      },
      关节: {
        bgColor: "#F7E0C9",
        demand: "关节",
      },
      睡眠: {
        bgColor: "#CAC9D3",
        demand: "睡眠",
      },
      消化: {
        bgColor: "#D0E0DA",
        demand: "消化",
      },
      胃肠道: {
        bgColor: "#D0E0DA",
        demand: "胃肠道",
      },
      头发: {
        bgColor: "#C5BFAD",
        demand: "头发",
      },
      头发头皮: {
        bgColor: "#C5BFAD",
        demand: "头发头皮",
      },
      骨骼: {
        bgColor: "#F0E8DF",
        demand: "骨骼",
      },
      骨骼关节: {
        bgColor: "#F0E8DF",
        demand: "骨骼关节",
      },
      大脑: {
        bgColor: "#D4C4B5",
        demand: "大脑",
      },
      眼睛: {
        bgColor: "#FAD8BE",
        demand: "眼睛",
      },
      HPV: {
        bgColor: "#EBCDBB",
        demand: "HPV",
      },
      孕期: {
        bgColor: "#E9C9B7",
        demand: "HPV",
      },
      减重: {
        bgColor: "#CEE9E8",
        demand: "减重",
      },
      护肝: {
        bgColor: "#DFCDB9",
        demand: "护肝",
      },
      贫血: {
        bgColor: "#E2C1C4",
        demand: "贫血",
      },
      肾脏: {
        bgColor: "#CFD8DA",
        demand: "肾脏",
      },
    },
    goodsPointList: [
      "第四代活性叶酸+甲钴胺B12",
      "第四代活性叶酸+甲钴胺B12",
      "第四代活性叶酸+甲钴胺B12",
    ],
    isArrowVisible: false,

    position: "bottom",
    left: 0,
    top: 0,
  }),
  mounted() {
    new Swiper(".swiper-container_m", {
      // 启用自动播放
      autoplay: {
        delay: 3000, // 幻灯片切换间隔时间（毫秒）
        disableOnInteraction: false, // 用户操作后是否停止自动播放
      },
      speed: 800, // 切换动画速度（毫秒）
      slidesPerView: 1, // 每个视图显示 1.5 个滑块
      spaceBetween: 0, // 滑块之间的间隙
      centeredSlides: true, // 活动块居中
      loop: true, // 循环模式
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
        // bulletClass: "custom-bullet",
        // bulletActiveClass: "custom-bullet-active",
      },
    });
    this.getGoodsList();
    this.getCustomerList();
    console.log("index.vue");
    if (
      this.$route.query.obj !== "undefined" &&
      typeof this.$route.query.obj !== "undefined"
    ) {
      localStorage.setItem("info", this.$route.query.obj);
      console.log("本地info缓存", localStorage.getItem("info"));
    }
    console.log("111111", this.$route.query);
    if (this.$route.query) {
      if (
        this.$route.query.source_id !== "undefined" &&
        typeof this.$route.query.source_id !== "undefined"
      ) {
        console.log("222222", this.$route.query.source_id);
        localStorage.setItem("sourceId", this.$route.query.source_id);
      }
      if (
        this.$route.query.creative_id !== "undefined" &&
        typeof this.$route.query.creative_id !== "undefined"
      ) {
        console.log("222222", this.$route.query.creative_id);
        localStorage.setItem("creativeId", this.$route.query.creative_id);
      }
    }
    // alert(JSON.parse(this.$route.query.obj))
    window.addEventListener("scroll", this.handleScroll);
    var w = window.screen.width;
    var h = window.screen.height;
    if (h / w > 1.873) {
      //console.log('111')
      this.isposition = true;
    }
    var zhi = localStorage.getItem("zhi") ? localStorage.getItem("zhi") : "";
    var ztimestamp = localStorage.getItem("ztimestamp")
      ? localStorage.getItem("ztimestamp")
      : "";
    if (zhi) {
      var tzhi = zhi + ztimestamp;
      this.biaoshi = md5(tzhi).toUpperCase();
    } else {
      //console.log('请刷新页面')
    }
    var that = this;
    setTimeout(function () {
      that.bt = true;
    }, 500);
    if (
      this.$route.query.obj !== "undefined" &&
      typeof this.$route.query.obj !== "undefined"
    ) {
      if (JSON.parse(localStorage.getItem("info")).pageName !== "") {
        let way = JSON.parse(localStorage.getItem("info")).pageName;
        if (way == "questionnaire") {
          this.$router.push({
            path: "home",
          });
        } else {
          this.$router.push({
            path: way,
          });
        }
      } else {
        this.$router.push({
          path: "/",
        });
      }
    } else {
      this.$router.push({
        path: "/",
      });
    }
    console.log("fewfewfe", localStorage.getItem("info"));
    var info = JSON.parse(localStorage.getItem("info"))
      ? JSON.parse(localStorage.getItem("info"))
      : {
          token: "",
        };
    that.info = info;
    if (JSON.parse(localStorage.getItem("info"))) {
      this.getbuyplan();
    } else {
      this.hasbuyplan = false;
    }
    window.addEventListener("scroll", this.gundong);
    setTimeout(that.showit, 1000);

    this.getbanner();
    this.getNoticeList();
    this.getindex();
  },
  created() {
    this.shanghaishow = sessionStorage.getItem("shanghaishow");
  },
  methods: {
    toMake(event) {
      const screenWidth = window.innerWidth;
      const screenHeight = window.innerHeight;
      let clickX = event.clientX; // 相对于视口的X坐标
      let clickY = event.clientY; // 相对于视口的Y坐标
      // 判断水平方向
      const horizontal = clickX < screenWidth / 2 ? "左" : "右";
      // 判断垂直方向
      const vertical = clickY < screenHeight / 2 ? "上" : "下";
      console.log(clickX, clickY);
      switch (horizontal + vertical) {
        case "左上":
          clickX = clickX / 54 + 3;
          clickY = clickY / 54 + 1 - 5;
          break;
        case "左下":
          clickX = clickX / 54 + 3;
          clickY = clickY / 54 - 8.5 + 5;
          break;
        case "右上":
          clickX = clickX / 54 - 10;
          clickY = clickY / 54 + 1.5 - 5;
          break;
        case "右下":
          clickX = clickX / 54 - 10;
          clickY = clickY / 54 - 9 + 5;
          break;
      }
      this.left = clickX;
      this.top = clickY;
      console.log('this.$refs.myPupop.showPupop()----',this.left,this.top)
      this.$refs.myPupop.showPupop();
    },
    getGoodsList() {
      this.$ajax
        .post(this.API.api.apiurl.getWebGoodsList, {}, {})
        .then((res) => {
          // this.goodsList = res.data.data.filter(x=>x.id!=83);
          // this.goodsList =res.data.data;
          this.goodsList = (res.data.data || []).slice(0, 30);

          console.log("getGoodsList", this.goodsList);
        });
    },
    showArrow() {
      this.isArrowVisible = true;
    },
    hiddeArrow() {
      this.isArrowVisible = false;
    },
    getCustomerList() {
      const customerList = [];
      // 循环生成七个图片元素
      for (let i = 1; i <= 7; i++) {
        customerList.push(
          `https://nutripacks-static.oss-cn-shenzhen.aliyuncs.com/static/official_website/index/customer/customer-${i}.png`
        );
      }
      this.customerList = customerList;
      // 打印生成的数组
      console.log(this.customerList);
    },
    scrollCardsRight() {
      if (this.scrollLeft >= (4.3 + 0.33) * 4) {
        console.log("到底了");
        return;
      }
      this.scrollLeft = Number((this.scrollLeft + (4.3 + 0.33)).toFixed(2));
      console.log("1111", this.scrollLeft);
    },
    scrollCardsLeft() {
      if (this.scrollLeft < 0 || this.scrollLeft === 0) {
        this.scrollLeft = 0;
        return;
      }
      this.scrollLeft = Number((this.scrollLeft - (4.3 + 0.33)).toFixed(2));
      console.log("1111", this.scrollLeft);
    },
    scrollCustomerRight() {
      if (this.customerScrollLeft >= (6.67 + 0.33) * 3) {
        console.log("到底了");
        return;
      }
      this.customerScrollLeft = Number(
        (this.customerScrollLeft + (6.67 + 0.33)).toFixed(2)
      );
      console.log("1111", this.customerScrollLeft);
    },
    scrollCustomerLeft() {
      if (this.customerScrollLeft < 0 || this.customerScrollLeft === 0) {
        this.customerScrollLeft = 0;
        return;
      }
      this.customerScrollLeft = Number(
        (this.customerScrollLeft - (6.67 + 0.33)).toFixed(2)
      );
      console.log("1111", this.customerScrollLeft);
    },
    getindex() {
      var that = this;
      this.$ajax
        .post(this.API.api.apiurl.getIndex, {})
        .then((res) => {
          var data = res.data;
          if (data.code == 0) {
            localStorage.setItem("indexdata", JSON.stringify(data.data));
            var inlist = data.data;
            inlist.home_img.forEach((item) => {
              if (item.image_no == 3) {
                that.npurl = item.url;
              } else if (item.image_no == 4) {
                that.center.c1 = item.url;
              } else if (item.image_no == 5) {
                that.center.d1 = item.url;
              } else if (item.image_no == 16) {
                that.center.c2 = item.url;
              } else if (item.image_no == 49) {
                that.center.c3 = item.url;
              }
            });
          } else {
            //console.log('错误：' + data.message)
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getbuyplan() {
      var that = this;
      this.$ajax
        .post(
          this.API.api.apiurl.getBuyPlanV2,
          {
            member_id: that.info.member_id,
          },
          {
            headers: {
              Authorization: "Bearer " + that.info.token,
            },
          }
        )
        .then((res) => {
          if (res.data.code == 0) {
            var data = res.data.data;
            if (data[0].id == 14) {
              that.hasbuyplan = true;
            }
          } else {
            //console.log('错误：' + res.res.data.message)
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    handleScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop > 0) {
        var w = window.screen.width;
        var h = window.screen.height;
        var hh = h + scrollTop;
        if (hh / w > 1.873) {
          this.isposition = true;
        } else {
          this.isposition = false;
        }
      }
    },
    gothere(url) {
      window.open(url);
    },
    logout() {
      this.$router.push({
        path: "login",
      });
    },
    getNoticeList() {
      var that = this;
      this.$ajax
        .post(this.API.api.apiurl.getNoticeList, {
          type: [6],
        })
        .then((res) => {
          var data = res.data;
          if (data.code == 0) {
            console.log("getNoticeList", data);
            that.noticelist = data.data.type_6;
            setTimeout(function () {
              new Swiper(".swiper-container", {
                loop: true,
                pagination: {
                  el: ".swiper-pagination",
                  clickable: true,
                },
                autoplay: {
                  delay: 3000, //时间 毫秒
                  disableOnInteraction: false, //用户操作之后是否停止自动轮播默认true
                },
              });
            }, 1000);
          } else {
            //console.log('错误：' + data.message)
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getbanner() {
      var that = this;
      this.$ajax
        .post(this.API.api.apiurl.getBannerList)
        .then((res) => {
          var data = res.data;
          if (data.code == 0) {
            console.log(data, "---------------");
            that.banner = data.data.index_list;
            that.duibi = data.data.element_list;
            that.anli = data.data.user_stories;
          } else {
            //console.log('错误：' + data.message)
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    golist(e) {
      if (e == 1) {
        window.open(
          "http://mp.weixin.qq.com/s?__biz=MzU4NTc2OTQxMA==&mid=100007381&idx=1&sn=7fb1b9f0cf246fe87b0fc11d1782b464&chksm=7d84d5784af35c6ee70698503c4a2dd06aae94630522af292b28e8a175827a82e7a26478f559#rd"
        );
      } else if (e == 2) {
        window.open(
          "http://mp.weixin.qq.com/s?__biz=MzU4NTc2OTQxMA==&mid=100000609&idx=1&sn=b535cb2ddf905f24858f5210adccb940&chksm=7d84cbcc4af342da7a2bcbd12503a97dc716dae5f47f681b7daa19e9b1e348fea4096f860b7c#rd"
        );
      } else if (e == 3) {
        window.open(
          "http://mp.weixin.qq.com/s?__biz=MzU4NTc2OTQxMA==&mid=100007377&idx=1&sn=e25d8a0a26da362bc19ac35a590092a2&chksm=7d84d57c4af35c6a384ea4d29de9bb5439742736374c7537b9a3370db19b10c3fce57629c387#rd"
        );
      } else if (e == 4) {
        window.open(
          "http://mp.weixin.qq.com/s?__biz=MzU4NTc2OTQxMA==&mid=100007379&idx=1&sn=9794dc1e06a82abae9ee680fdbd09ff9&chksm=7d84d57e4af35c68e8d8d4d67ed132cc533a30f8e1940b094519da2909d7f7e46284b9ce836d#rd"
        );
      } else if (e == 5) {
        window.open(
          "http://mp.weixin.qq.com/s?__biz=MzU4NTc2OTQxMA==&mid=100007378&idx=1&sn=1e5486f679f0096f4acec15f6538188e&chksm=7d84d57f4af35c69eee04db176a1a89867057b029b5b7077bdac99ae3eec99e86bcd492410ec#rd"
        );
      } else if (e == 6) {
        window.open(
          "http://mp.weixin.qq.com/s?__biz=MzU4NTc2OTQxMA==&mid=100007380&idx=1&sn=b96cc5a79e0cd5c2d579360d95fb3a22&chksm=7d84d5794af35c6f2d63fee1662e46791c806248f252b8fc709f858d8ea66acc795e62f75fa4#rd"
        );
      } else if (e == 7) {
        this.$router.push({
          path: "home",
        });
      } else if (e == 8) {
        window.open("https://nutripacks.mikecrm.com/i4tUtKz");
      } else if (e == 10) {
        this.$router.push({
          path: "care-packs",
        });
      }
    },

    goxcx() {
      const sourceId = localStorage.getItem("sourceId");
      window.location.href = sourceId
        ? "https://api.xiaojudai.cn/api/s/27?source_id=" + sourceId
        : "https://api.xiaojudai.cn/api/s/2";
    },
    golist1(e) {
      if (e == 1) {
        if (navigator.userAgent.indexOf("AliApp") > -1) {
          return;
        }
        window.location.href =
          "http://mp.weixin.qq.com/s?__biz=MzU4NTc2OTQxMA==&mid=100007381&idx=1&sn=7fb1b9f0cf246fe87b0fc11d1782b464&chksm=7d84d5784af35c6ee70698503c4a2dd06aae94630522af292b28e8a175827a82e7a26478f559#rd";
      } else if (e == 2) {
        if (navigator.userAgent.indexOf("AliApp") > -1) {
          return;
        }
        window.location.href =
          "http://mp.weixin.qq.com/s?__biz=MzU4NTc2OTQxMA==&mid=100000609&idx=1&sn=b535cb2ddf905f24858f5210adccb940&chksm=7d84cbcc4af342da7a2bcbd12503a97dc716dae5f47f681b7daa19e9b1e348fea4096f860b7c#rd";
      } else if (e == 3) {
        if (navigator.userAgent.indexOf("AliApp") > -1) {
          return;
        }
        window.location.href =
          "http://mp.weixin.qq.com/s?__biz=MzU4NTc2OTQxMA==&mid=100007377&idx=1&sn=e25d8a0a26da362bc19ac35a590092a2&chksm=7d84d57c4af35c6a384ea4d29de9bb5439742736374c7537b9a3370db19b10c3fce57629c387#rd";
      } else if (e == 4) {
        if (navigator.userAgent.indexOf("AliApp") > -1) {
          return;
        }
        window.location.href =
          "http://mp.weixin.qq.com/s?__biz=MzU4NTc2OTQxMA==&mid=100007379&idx=1&sn=9794dc1e06a82abae9ee680fdbd09ff9&chksm=7d84d57e4af35c68e8d8d4d67ed132cc533a30f8e1940b094519da2909d7f7e46284b9ce836d#rd";
      } else if (e == 5) {
        if (navigator.userAgent.indexOf("AliApp") > -1) {
          return;
        }
        window.location.href =
          "http://mp.weixin.qq.com/s?__biz=MzU4NTc2OTQxMA==&mid=100007378&idx=1&sn=1e5486f679f0096f4acec15f6538188e&chksm=7d84d57f4af35c69eee04db176a1a89867057b029b5b7077bdac99ae3eec99e86bcd492410ec#rd";
      } else if (e == 6) {
        if (navigator.userAgent.indexOf("AliApp") > -1) {
          return;
        }
        window.location.href =
          "http://mp.weixin.qq.com/s?__biz=MzU4NTc2OTQxMA==&mid=100007380&idx=1&sn=b96cc5a79e0cd5c2d579360d95fb3a22&chksm=7d84d5794af35c6f2d63fee1662e46791c806248f252b8fc709f858d8ea66acc795e62f75fa4#rd";
      } else if (e == 7) {
        if (navigator.userAgent.indexOf("AliApp") > -1) {
          console.log("支付宝小程序");
          this.$router.push({
            path: "home",
          });
        } else {
          console.log("非支付宝小程序");
          const sourceId = localStorage.getItem("sourceId");
          window.location.href = sourceId
            ? "https://api.xiaojudai.cn/api/s/27?source_id=" + sourceId
            : "https://api.xiaojudai.cn/api/s/2";
        }
      } else if (e == 8) {
        window.location.href = "https://nutripacks.mikecrm.com/i4tUtKz";
      }
    },
  },
};
</script>
<style scoped >
/* 大于768的样式 */
@media screen and (min-width: 769px) {
  /deep/ .el-carousel__arrow {
    top: 5.95rem;
    /* left: 1.48rem; */
    width: 1.2rem;
    height: 1.2rem;
    font-size: 0.5rem;
    z-index: 3;
  }

  /deep/.el-carousel__arrow i {
    font-size: 0.5rem;
  }

  /deep/.el-carousel__arrow--left {
    left: 1.48rem;
  }

  /deep/.el-carousel__arrow--right {
    right: 1.48rem;
  }
}

@media screen and (min-width: 768px) and (max-width: 1439px) {
  /deep/ .swiper-pagination-bullet {
    width: 0.22rem !important;
    height: 0.22rem !important;
  }
}
@media screen and (min-width: 1440px) and (max-width: 1919px) {
  /deep/.el-carousel__arrow i {
    color: rgba(0, 0, 0, 0.6);
    font-weight: bold;
  }
}
</style>

<style scoped lang="scss">
/* 统一鼠标样式 */
.cursor {
  cursor: pointer;
}

// mobile414
@media screen and (max-width: 767px) {
  body {
    overflow-x: hidden !important;
  }
  .web {
    display: none;
  }

  .mobile {
    margin: 1.38rem 0 0 0;
    overflow-x: hidden;
    overflow-y: scroll;
    background-color: white;
  }
  .swiper-container_m {
    height: 14.08rem;
    background-color: #f6f4f1;

    .swiper-wrapper {
      height: 14.08rem;
      position: relative;
      .swiperItem {
        width: 100%;
        height: 14.08rem;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;

        background-size: cover;
        padding-bottom: 2.17rem;
        box-sizing: border-box;
        background-repeat: no-repeat;
        position: relative;
        .top-tags-text {
          font-family: PingFangSC, PingFang SC;
          font-weight: 100;
          font-size: 0.27rem;
          color: #1a1a1a;
          line-height: 0.39rem;
          display: flex;
          align-items: center;
          justify-content: center;
          position: absolute;
          top: 7.27rem;

          left: 0;
          width: 100%;
          span {
            margin-right: 0.41rem;
          }
          span:first-child {
            // margin-left: -1rem;
          }
          span:last-child {
            margin-right: 0;
          }
        }
        .top-title {
          margin: 0.94rem 0 0 0;
          font-family: MADEEvolveSans, MADEEvolveSans;
          font-weight: bold;
          font-size: 0.72rem;
          color: #1a1a1a;
          line-height: 0.87rem;
          font-style: normal;
        }

        .top-title-ch {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 0.31rem;
          color: #1a1a1a;
          line-height: 0.43rem;
          margin: 0.29rem 0 0 0;
        }
      }
      .swiperItem_bgHeight {
        background-size: 100% 7.27rem;
      }
      .top-title_mt {
        margin-top: 5rem;
      }
    }
    .swiper-pagination {
      // bottom: 7.42rem;
      bottom: 0rem;
      left: 0;
      top: 14.5rem;
      z-index: 1 !important;
      height: 20px;
      // background-color: red;
    }
  }

  .step-module {
    padding: 0 0 1.86rem 0;
  }

  .step-module-title {
    font-family: MADEEvolveSans, MADEEvolveSans;
    font-weight: bold;
    font-size: 0.72rem;
    color: #1a1a1a;
    line-height: 0.87rem;
    margin: 1.47rem 0 0 0;
  }

  .step-module-title-ch {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 0.31rem;
    color: #333333;
    line-height: 0.43rem;
    margin: 0.29rem 0 0 0;
  }

  .step-items {
    display: flex;
    overflow-y: hidden;
    overflow-x: scroll;
    padding: 0 0 0.1rem 0.58rem;
    margin: 1.62rem 0 0 0;
    /* 隐藏 WebKit 浏览器的滚动条 */
    -webkit-overflow-scrolling: touch;
    /* 隐藏滚动条 */
    scrollbar-width: none;
  }

  .step-items::-webkit-scrollbar {
    display: none;
  }

  .step-item-tips {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 1.55rem;
    height: 0.58rem;
    background: #ffffff;
    border-radius: 0.43rem;
    border: 0.02rem solid #000000;
  }

  .step-item {
    width: 5.21rem;
    height: 7.22rem;
    border-radius: 0.19rem;
    border: 0.02rem solid #e5e5e5;
    padding: 0.27rem 0 0;
    box-sizing: border-box;
    margin: 0.48rem 0.22rem 0 0;
    flex-shrink: 0;
  }

  .step-item img {
    width: 4.69rem;
    height: 4.69rem;
    border-radius: 0.19rem;
    object-fit: cover;
  }

  .step-item-title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 0.34rem;
    color: #141414;
    line-height: 0.34rem;
    margin: 0.46rem 0 0 0;
    text-align: left;
    padding: 0 0 0 0.36rem;
  }

  .step-item-description {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 0.27rem;
    color: #141414;
    line-height: 0.43rem;
    margin: 0.21rem 0 0 0;
    text-align: left;
    padding: 0 0.27rem 0 0.39rem;
  }

  .quality-module {
    background-image: url("https://nutripacks-static.oss-cn-shenzhen.aliyuncs.com/static/official_website/index/quality-bg.png");
    background-size: cover; /* 使背景图覆盖整个容器，可根据需求调整，如 contain 保持比例显示 */
    background-repeat: no-repeat; /* 防止背景图重复 */
    width: 100vw; /* 宽度为整个屏幕宽度 */
    min-height: 100vh; /* 可设置最小高度，保证初始状态有一定高度，可按需调整或去掉 */
    box-sizing: border-box; /* 保证内边距和边框不影响宽度计算 */
    padding: 0 0 1.96rem 0;
  }

  .quality-title {
    font-family: MADEEvolveSans, MADEEvolveSans;
    font-weight: bold;
    font-size: 0.72rem;
    color: #ffffff;
    line-height: 0.87rem;
    padding: 1.45rem 0 0 0;
  }

  .quality-title-ch {
    width: 7.68rem;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 0.29rem;
    color: #ffffff;
    line-height: 0.58rem;
    text-align: center;
    margin: 0.58rem auto 0;
  }

  .quality-demand-tags {
    display: flex;
    flex-wrap: wrap;
    margin: 0.58rem 0 0 0;
    padding: 0 0.58rem;
  }

  .quality-tag {
    display: flex;
    align-items: center;
    padding: 0.05rem 0.22rem;
    background: rgba(255, 255, 255, 0.21);
    border-radius: 0.56rem;
    border: 0.01rem solid #ffffff;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 0.29rem;
    color: #ffffff;
    line-height: 0.48rem;
    margin: 0 0.1rem 0.14rem 0;
  }
  .goods-wrap {
    position: relative;
    overflow-x: auto;
    margin: 0.97rem 0 0 0;
    padding-left: 0.58rem;
    /* 隐藏 WebKit 浏览器的滚动条 */
    -webkit-overflow-scrolling: touch;
    /* 隐藏滚动条 */
    scrollbar-width: none;
  }

  .goods-wrap::-webkit-scrollbar {
    display: none;
  }

  .goods-items {
    display: grid;
    grid-template-columns: repeat(10, 3.67rem);
    gap: 0.24rem;
    transition: transform 0.3s ease;
  }

  .goods-item {
    position: relative;
    width: 3.67rem;
    height: 4.8rem;
    background: #ffffff;
    border-radius: 0.19rem;
    background-size: cover;
    // background-position: center;
    padding: 0 0 0 0.29rem;
    box-sizing: border-box;
  }

  .goods-item-image {
    position: absolute;
    right: -0.27rem;
    top: 0.17rem;
    width: 1.96rem;
    height: auto;
  }

  .demand {
    position: absolute;
    top: 1.4rem;
    display: flex;
    flex-wrap: wrap;
    width: 1.67rem;
  }

  .tag {
    padding: 0.02rem 0.05rem;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 0.14rem;
    color: #141414;
    // line-height: 0.14rem;
    background: #ebcdbb;
    border-radius: 0.28rem;
    margin: 0.05rem 0.05rem 0 0;
    display: flex;
    align-items: center;
  }

  .goods-item-info {
    text-align: left;
  }

  .goods-name {
    font-family: SourceHanSansCN, SourceHanSansCN;
    font-weight: 800;
    font-size: 0.29rem;
    color: #141414;
    line-height: 0.48rem;
    margin: 2.29rem 0 0 0;
  }

  .goods-name-en {
    font-family: MADEEvolveSans;
    font-size: 0.17rem;
    color: #141414;
    line-height: 0.17rem;
    margin: 0.07rem;
  }

  .goods-point {
    margin: 0.19rem 0 0 0;
  }

  .goods-point-item {
    font-family: SourceHanSansCN, SourceHanSansCN;
    font-weight: 300;
    font-size: 0.14rem;
    color: #666666;
    line-height: 0.15rem;
    margin: 0 0 0.07rem 0;
    white-space: nowrap; /* 禁止文本换行 */
    overflow: hidden; /* 隐藏超出容器的内容 */
    text-overflow: ellipsis; /* 超出部分显示为省略号 */
    position: relative;
    padding-left: 0.12rem;
  }
  .goods-point-item::before {
    content: "";
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 0.05rem;
    height: 0.05rem;
    border-radius: 50%;
    background: #999999;
  }

  .promise {
    margin: 1.47rem 0 0 0;
  }

  .promise-wrap {
    position: relative;
    width: 4.04rem;
    height: 7.03rem;
    background: rgba(255, 255, 255, 0.22);
    border-radius: 0 0.97rem 0.97rem 0rem;
    border-top: 0.02rem solid #ffffff;
    border-right: 0.02rem solid #ffffff;
    border-bottom: 0.02rem solid #ffffff;

    backdrop-filter: blur(15px);
    text-align: left;
  }

  .promise-title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 0.72rem;
    color: #ffffff;
    line-height: 1.01rem;
  }

  .promise-description {
    width: 8.84rem;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 0.29rem;
    color: #ffffff;
    line-height: 0.58rem;
    text-align: center;
    margin: 0.48rem auto 1.45rem;
  }
  .promise-description_768 {
    display: none;
  }
  .promise-goods-img {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translate(50%, -50%);
    width: 1.93rem;
    height: auto;
  }

  .promise-tags-image {
    position: absolute;
    right: -4.83rem;
    top: 50%;
    transform: translateY(-50%);
    width: 3.55rem;
    height: 4.73rem;
  }

  .guarantee-module {
  }

  .guarantee-top {
    margin: 1.45rem 0 0 0;
    box-sizing: border-box;
  }

  .guarantee-title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 0.72rem;
    color: #1a1a1a;
    line-height: 1.01rem;
  }

  .guarantee-items {
    margin: 0.89rem 0 0 0;
    position: relative;
    padding: 0 0.82rem 0 0.58rem;
  }

  .guarantee-item {
    display: flex;
    justify-content: center;
    margin: 0 0 0.6rem 0;
  }

  .guarantee-item-icon {
    width: 1.64rem;
    height: 1.64rem;
  }

  .guarantee-item-right {
    text-align: left;
    margin: 0 0 0 0.34rem;
  }

  .guarantee-item-right-title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 0.31rem;
    color: #1a1a1a;
    line-height: 0.43rem;
  }

  .guarantee-item-right-description {
    font-family: PingFangSC, PingFang SC;
    font-weight: 300;
    font-size: 0.27rem;
    color: #333333;
    line-height: 0.43rem;
  }

  .guarantee-bottom {
    // width: 100%;
    // height: auto;
    // margin: -1.2rem 0 0 0;

    width: 100%;
    height: 12.34rem;
    background-size: 180% 100%;
    background-position: -5.0725rem -1.2rem;
  }
  .guarantee-bottom_768 {
    display: none;
  }

  .customer-module {
    position: relative;
    background: #f6f4f1;
    padding: 1.47rem 0 1.93rem;
    // margin: -1.47rem 0 0 0;
    margin: -2.6rem 0 0 0;
  }

  .customer-title {
    font-family: MADEEvolveSans, MADEEvolveSans;
    font-weight: bold;
    font-size: 0.72rem;
    color: #141414;
    line-height: 1.45rem;
  }

  .customer-title-ch {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 0.31rem;
    color: #000000;
    line-height: 0.43rem;
    margin: 0.19rem 0 0 0;
  }

  .customer-wrap {
    position: relative;
    overflow-x: auto;
    margin: 1.45rem 0 0 0;
    padding-left: 0.58rem;
    /* 隐藏 WebKit 浏览器的滚动条 */
    -webkit-overflow-scrolling: touch;
    /* 隐藏滚动条 */
    scrollbar-width: none;
  }

  .customer-wrap::-webkit-scrollbar {
    display: none;
  }

  .customer-items {
    display: grid;
    grid-template-columns: repeat(7, 7.68rem);
    gap: 0.41rem;
    transition: transform 0.3s ease;
  }

  .customer-item {
    width: 7.68rem;
    height: 10.24rem;
    border-radius: 0.21rem;
  }

  .bottom {
  }

  .bottom-title {
    font-family: MADEEvolveSans;
    font-size: 0.31rem;
    color: #141414;
    line-height: 0.53rem;
    margin: 1.96rem 0 0 0;
  }

  .company-image {
    width: 7.81rem;
    height: auto;
    margin: 0.97rem 0 0 0;
  }

  .bottom-banner-wrap {
    margin: 2.13rem 0 0 0;
  }

  .bottom-banner {
    width: 8.85rem;
    height: auto;
    border-radius: 0.19rem;
  }

  .bottom-banner-title {
    font-family: MADEEvolveSans, MADEEvolveSans;
    font-weight: bold;
    font-size: 0.72rem;
    color: #141414;
    line-height: 1.45rem;
    margin: 0.85rem 0 0 0;
  }

  .bottom-banner-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 5.89rem;
    height: 1.06rem;
    background: #c25e4d;
    border-radius: 0.97rem;
    margin: 0.31rem auto 1.93rem;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 0.31rem;
    color: #ffffff;
    .arrR {
      width: 0.37rem;
      height: 0.3rem;
      margin-left: 0.22rem;
    }
  }
}
//pad768
@media screen and (min-width: 768px) and (max-width: 1439px) {
  body {
    overflow-x: hidden !important;
  }
  .web {
    display: none;
  }

  .mobile {
    margin: 1.38rem 0 0 0;
    overflow-x: hidden;
    overflow-y: scroll;

    background-color: white;
  }
  .swiper-container_m {
    height: 18.72rem;
    box-sizing: border-box;
    background-color: #f6f4f1;
    .swiper-wrapper {
      height: 18.72rem;
      box-sizing: border-box;

      position: relative;
      .swiperItem {
        width: 100%;
        height: 18.72rem;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;

        // background-size: 100% 100%;
        background-size:cover;

        padding-bottom: 4.63rem;
        box-sizing: border-box;
        background-repeat: no-repeat;
        position: relative;
        .top-tags-text {
          font-family: PingFangSC, PingFang SC;
          font-weight: 100;
          font-size: 0.3rem;
          color: #1a1a1a;
          line-height: 0.41rem;

          display: flex;
          align-items: center;
          justify-content: center;
          position: absolute;
          top: 9.43rem;

          left: 0;
          width: 100%;
          span {
            margin-right: 1.09rem;
          }
          span:first-child {
            // margin-left: -1rem;
          }
          span:last-child {
            margin-right: 0;
          }
        }
        .top-title {
          margin: 0rem 0 0 0;

          font-family: MADEEvolveSans, MADEEvolveSans;
          font-weight: bold;
          font-size: 0.81rem;
          color: #1a1a1a;
          line-height: 0.96rem;

          font-style: normal;
        }

        .top-title-ch {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 0.41rem;
          color: #1a1a1a;
          line-height: 0.56rem;

          margin: 0.48rem 0 0 0;
        }
      }
      .swiperItem_bgHeight {
        background-size: 100% 10.31rem;
      }
      .swiperItem_pb {
        padding-bottom: 3.26rem;
      }
    }
    .swiper-pagination {
      // bottom: 7.42rem;
      bottom: 0rem;
      left: 0;
      top: 19rem;
      z-index: 1 !important;
      height: 0.22rem;
      // background-color: red;
    }
  }

  .step-module {
    padding: 0 0 1.85rem 0;
  }

  .step-module-title {
    font-family: MADEEvolveSans, MADEEvolveSans;
    font-weight: bold;
    font-size: 0.81rem;
    color: #1a1a1a;
    line-height: 0.96rem;

    margin: 1.85rem 0 0 0;
  }

  .step-module-title-ch {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 0.41rem;
    color: #333333;
    line-height: 0.56rem;

    margin: 0.44rem 0 0 0;
  }

  .step-items {
    display: flex;
    overflow-y: hidden;
    overflow-x: scroll;

    padding: 0 0 0rem 0.81rem;
    margin: 1.62rem 0 0 0;

    /* 隐藏 WebKit 浏览器的滚动条 */
    -webkit-overflow-scrolling: touch;
    /* 隐藏滚动条 */
    scrollbar-width: none;
  }

  .step-items::-webkit-scrollbar {
    display: none;
  }

  .step-item-tips {
    display: flex;
    align-items: center;
    justify-content: center;

    width: 1.78rem;
    height: 0.67rem;
    background: #ffffff;
    border-radius: 0.33rem;
    border: 0.02rem solid #000000;
  }

  .step-item {
    width: 7.41rem;
    height: 9.52rem;
    border-radius: 0.15rem;
    border: 0.02rem solid #e5e5e5;

    padding: 0.37rem 0 0;
    box-sizing: border-box;

    margin: 0.67rem 0.33rem 0 0;
    flex-shrink: 0;
  }

  .step-item img {
    width: 6.67rem;
    height: 6.67rem;
    // border-radius: 0.19rem;
    object-fit: cover;
  }

  .step-item-title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 0.33rem;
    color: #141414;
    line-height: 0.44rem;

    margin: 0.52rem 0 0 0;
    text-align: left;
    padding: 0 0 0 0.52rem;
  }

  .step-item-description {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 0.26rem;
    color: #141414;
    line-height: 0.43rem;

    margin: 0.15rem 0 0 0;
    text-align: left;
    padding: 0 0.27rem 0 0.52rem;
  }

  .quality-module {
    background-image: url("https://nutripacks-static.oss-cn-shenzhen.aliyuncs.com/static/official_website/index/quality-bg.png");
    background-size: cover; /* 使背景图覆盖整个容器，可根据需求调整，如 contain 保持比例显示 */
    background-repeat: no-repeat; /* 防止背景图重复 */
    width: 100vw; /* 宽度为整个屏幕宽度 */
    // min-height:38.96rem; /* 可设置最小高度，保证初始状态有一定高度，可按需调整或去掉 */
    box-sizing: border-box; /* 保证内边距和边框不影响宽度计算 */
    padding: 0 0 1.83rem 0;
  }

  .quality-title {
    font-family: MADEEvolveSans, MADEEvolveSans;
    font-weight: bold;
    font-size: 0.81rem;
    color: #ffffff;
    line-height: 0.96rem;

    padding: 1.45rem 0 0 0;
  }

  .quality-title-ch {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 0.3rem;
    color: #ffffff;
    line-height: 0.59rem;

    text-align: center;
    margin: 0.52rem auto 0;
  }

  .quality-demand-tags {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin: 0.67rem 0 0 0;
    padding: 0 0.81rem;
  }

  .quality-tag {
    display: flex;
    align-items: center;

    padding: 0.15rem 0.36rem;
    background: rgba(255, 255, 255, 0.21);
    border-radius: 0.43rem;
    border: 0.02rem solid #ffffff;

    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 0.33rem;
    color: #ffffff;
    line-height: 0.37rem;

    margin: 0 0.15rem 0.3rem 0;
  }
  .goods-wrap {
    position: relative;
    overflow-x: auto;
    margin: 0.79rem 0 0 0;

    padding-left: 0.81rem;
    /* 隐藏 WebKit 浏览器的滚动条 */
    -webkit-overflow-scrolling: touch;
    /* 隐藏滚动条 */
    scrollbar-width: none;
  }

  .goods-wrap::-webkit-scrollbar {
    display: none;
  }

  .goods-items {
    display: grid;
    grid-template-columns: repeat(10, 1fr);
    gap: 0.22rem;
    transition: transform 0.3s ease;
  }

  .goods-item {
    position: relative;

    width: 3.33rem;
    min-height: 4.28rem;
    background: #ffffff;
    border-radius: 0.15rem;

    background-size: cover;
    // background-position: center;
    padding: 0 0 0rem 0.24rem;
    box-sizing: border-box;
  }

  .goods-item-image {
    position: absolute;
    right: -0.22rem;
    top: 0.15rem;

    width: 1.76rem;
    height: auto;
  }

  .demand {
    position: absolute;
    top: 1.28rem;
    display: flex;
    flex-wrap: wrap;
    width: 1.56rem;
  }

  .tag {
    padding: 0.04rem 0.06rem;

    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 0.11rem;
    color: #141414;

    // line-height: 0.14rem;
    background: #ebcdbb;
    border-radius: 0.21rem;

    margin: 0.04rem 0.04rem 0 0;
    display: flex;
    align-items: center;
  }

  .goods-item-info {
    text-align: left;
  }

  .goods-name {
    font-family: SourceHanSansCN, SourceHanSansCN;
    font-weight: 800;
    font-size: 0.26rem;
    color: #141414;
    line-height: 0.37rem;

    margin: 2.17rem 0 0 0;
  }

  .goods-name-en {
    font-family: MADEEvolveSans;
    font-size: 0.15rem;
    color: #141414;
    line-height: 0.22rem;
    margin-top: 0.09rem;
  }

  .goods-point {
    margin: 0.17rem 0 0 0;
  }

  .goods-point-item {
    font-family: SourceHanSansCN, SourceHanSansCN;
    font-weight: 300;
    font-size: 0.13rem;
    color: #666666;
    line-height: 0.13rem;

    margin: 0 0 0.07rem 0;
    white-space: nowrap; /* 禁止文本换行 */
    overflow: hidden; /* 隐藏超出容器的内容 */
    text-overflow: ellipsis; /* 超出部分显示为省略号 */
    position: relative;
    padding-left: 0.12rem;
  }
  .goods-point-item::before {
    content: "";
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 0.05rem;
    height: 0.05rem;
    border-radius: 50%;
    background: #999999;
  }

  .promise {
    margin: 1.59rem 0 0 0;
  }

  .promise-wrap {
    position: relative;
    width: 5.75rem;
    height: 10rem;

    background: rgba(255, 255, 255, 0.22);
    border-radius: 0rem 0.93rem 0.93rem 0rem;

    border-top: 0.02rem solid #ffffff;
    border-right: 0.02rem solid #ffffff;
    border-bottom: 0.02rem solid #ffffff;

    backdrop-filter: blur(15px);
    text-align: left;
  }

  .promise-title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 0.74rem;
    color: #ffffff;
    line-height: 1.04rem;
  }

  .promise-description_768 {
    width: 13rem;

    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 0.3rem;
    color: #ffffff;
    line-height: 0.59rem;

    text-align: center;

    margin: 0.44rem auto 1.48rem;
  }
  .promise-description {
    display: none;
  }

  .promise-goods-img {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translate(50%, -50%);
    width: 2.74rem;
    height: auto;
  }

  .promise-tags-image {
    position: absolute;
    right: -7.19rem;
    top: 50%;
    transform: translateY(-50%);
    width: 4.63rem;
    height: 6.37rem;
  }

  .guarantee-module {
    padding-bottom: 0.67rem;
  }

  .guarantee-top {
    margin: 1.85rem 0 0 0;
    box-sizing: border-box;
  }

  .guarantee-title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 0.81rem;
    color: #1a1a1a;
    line-height: 1.15rem;
  }

  .guarantee-items {
    margin: 1.44rem 0 0 0;

    position: relative;
    padding: 0 1.04rem 0 1.02rem;

    display: flex;
    justify-content: space-between;
  }

  .guarantee-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 24vw;
  }

  .guarantee-item-icon {
    width: 1.26rem;
    height: 1.26rem;
  }

  .guarantee-item-right {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .guarantee-item-right-title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 0.3rem;
    color: #1a1a1a;
    line-height: 0.41rem;
    width: 2rem;

    margin-top: 0.37rem;
  }
  .guarantee-item:nth-child(2) .guarantee-item-right-title {
    width: 2.6rem;
  }
  .guarantee-item:nth-child(3) .guarantee-item-right-title {
    width: 2.6rem;
  }

  .guarantee-item-right-description {
    font-family: PingFangSC, PingFang SC;
    font-weight: 300;
    font-size: 0.22rem;
    color: #333333;
    line-height: 0.37rem;
    margin-top: 0.44rem;
  }

  .guarantee-bottom_768 {
    // width: 100%;
    // height: auto;
    // margin: -1.2rem 0 0 0;

    width: 100%;
    // height: 13.89rem;
    // background-size: 140% 100%;
    // background-position: -2.2rem -0rem;
  }
  .guarantee-bottom {
    display: none;
  }

  .customer-module {
    position: relative;
    background: #f6f4f1;
    padding: 1.85rem 0 1.85rem;
  }

  .customer-title {
    font-family: MADEEvolveSans, MADEEvolveSans;
    font-weight: bold;
    font-size: 0.81rem;
    color: #141414;
    line-height: 1.11rem;
  }

  .customer-title-ch {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 0.41rem;
    color: #000000;
    // line-height: 0.56rem;

    margin: 0.44rem 0 0 0;
  }

  .customer-wrap {
    position: relative;
    overflow-x: auto;
    margin: 1.48rem 0 0 0;
    padding-left: 0.81rem;
    /* 隐藏 WebKit 浏览器的滚动条 */
    -webkit-overflow-scrolling: touch;
    /* 隐藏滚动条 */
    scrollbar-width: none;
  }

  .customer-wrap::-webkit-scrollbar {
    display: none;
  }

  .customer-items {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    gap: 0.3rem;
    transition: transform 0.3s ease;
  }

  .customer-item {
    width: 5.57rem;
    height: 7.43rem;
    border-radius: 0.16rem;
  }

  .bottom {
  }

  .bottom-title {
    font-family: MADEEvolveSans;
    font-size: 0.41rem;
    color: #141414;
    line-height: 0.41rem;

    margin: 1.85rem 0 0 0;
  }

  .company-image {
    width: calc(100vw - 3.12rem);
    height: auto;
    margin: 1.11rem 0 0 0;
  }

  .bottom-banner-wrap {
    margin: 2.22rem 0 0 0;
  }

  .bottom-banner {
    width: calc(100vw - 1.62rem);
    height: auto;
    border-radius: 0.12rem;
  }

  .bottom-banner-title {
    font-family: MADEEvolveSans, MADEEvolveSans;
    font-weight: bold;
    font-size: 0.81rem;
    color: #141414;
    line-height: 1.11rem;

    margin: 1.48rem 0 0 0;
  }

  .bottom-banner-btn {
    display: flex;
    align-items: center;
    justify-content: center;

    width: 4.74rem;
    height: 1.3rem;
    background: #c25e4d;
    border-radius: 0.74rem;

    margin: 1.11rem auto 1.85rem;

    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 0.3rem;
    color: #ffffff;

    .arrR {
      width: 0.3rem;
      height: 0.2rem;
      margin-left: 0.19rem;
    }
  }
}
//小web1440
@media screen and (min-width: 1440px) and (max-width: 1919px) {
  .mobile {
    display: none;
  }
  .swpiperItem {
    .top {
      display: flex;
      justify-content: space-between;
      width: 100%;
      height: 11.89rem;
      // background: #f6f4f1;
      padding: 0 0.7rem 0 1.91rem;
      box-sizing: border-box;
    }

    .top-left {
      display: flex;
      flex-direction: column;
      justify-content: center;
      height: 100%;
      min-width: 6.6rem;
    }

    .top-left-one {
      font-family: MADEEvolveSans, MADEEvolveSans;
      font-weight: bold;
      font-size: 0.93rem;
      color: #1a1a1a;
      line-height: 1.09rem;
    }

    .top-left-one span {
      display: block;
      text-align: left;
    }

    .top-left-two {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 0.41rem;
      color: #1a1a1a;
      line-height: 0.56rem;
      margin: 0.5rem 0 0 0;
      text-align: left;
    }

    .top-left-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 3.15rem;
      height: 1.11rem;
      background: #c25e4d;
      border-radius: 0.74rem;
      margin: 1.11rem 0 0 0;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 0.33rem;
      color: #ffffff;
      line-height: 0.46rem;
    }

    .top-left-btn:hover {
      background-color: #d35e4f;
    }

    .top-right {
      position: relative;
      width: 14.72rem;
      height: 10.67rem;
    }

    .top-right-image {
      width: 14.72rem;
      height: 10.67rem;
    }
    .top-right2 {
      position: relative;
      width: 14.72rem;
      height: 100%;
      display: flex;
      align-items: center;
      .top-right-image {
        width: 14.72rem;
        height: 10.5rem;
      }
    }
    .top-right3 {
      position: relative;
      width: 14.72rem;
      height: 100%;
      display: flex;
      align-items: flex-end;
    }

    .top-right-text {
      position: absolute;
      left: 3.28rem;
      bottom: 0.54rem;
      font-family: PingFangSC, PingFang SC;
      font-weight: 100;
      font-size: 0.33rem;
      color: #1a1a1a;
      line-height: 0.46rem;
    }

    .top-right-text span {
      margin: 0 1.17rem 0 0;
    }
  }

  .step-module {
  }

  .step-module-title {
    font-family: MADEEvolveSans, MADEEvolveSans;
    font-weight: bold;
    font-size: 0.81rem;
    color: #1a1a1a;
    line-height: 0.96rem;

    margin: 2.22rem 0 0 0;
  }

  .step-module-title-ch {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 0.41rem;
    color: #333333;
    line-height: 0.56rem;
    margin: 0.19rem 0 0;
  }

  .stepItemBox {
    margin-left: 50%;
    transform: translateX(-50%);

    width: 22.89rem;
    margin-top: 2.8148rem;

    display: flex;
    justify-content: space-between;
    .item {
      position: relative;
      width: 7.41rem;
      height: 9.52rem;
      border-radius: 0.1481rem;
      border: 0.0185rem solid #e5e5e5;
      box-sizing: border-box;

      padding: 0.37rem;

      .tag {
        position: absolute;
        top: -1.3333rem;
        left: 0;
        width: 1.7778rem;
        height: 0.6667rem;
        background: #ffffff;
        border-radius: 0.3333rem;
        border: 0.0185rem solid #000000;
        display: flex;
        justify-content: center;
        align-items: center;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 0.3333rem;
        color: #000000;
        line-height: 0.4444rem;
        text-align: left;
        font-style: normal;
      }
      .pic {
        display: none;
      }
      .pic_1440 {
        width: 100%;
        height: 6.67rem;
      }
      .des1 {
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 0.3333rem;
        color: #141414;
        line-height: 0.4444rem;
        text-align: left;
        font-style: normal;
        margin-top: 0.5185rem;
      }
      .des2 {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 0.2593rem;
        color: #141414;
        line-height: 0.4444rem;
        text-align: left;
        font-style: normal;
        margin-top: 0.1481rem;
      }
    }
    .item:nth-child(2) {
      // .tag {
      //   left: -0.8889rem;
      // }
    }
    .item:nth-child(3) {
      // .tag {
      //   left: -2.037rem;
      // }
    }
  }
  .quality-module {
    // width: 35.56rem;
    width: 100%;
    // height: 42.11rem;
    background-image: url("https://nutripacks-static.oss-cn-shenzhen.aliyuncs.com/static/official_website/index/quality-bg.png");
    background-size: cover;
    background-position: center;
    margin: 2.22rem 0 0 0;
    padding-bottom: 2.98rem;
  }

  .quality-module-title {
    font-family: MADEEvolveSans, MADEEvolveSans;
    font-weight: bold;
    font-size: 0.81rem;
    color: #ffffff;
    line-height: 0.96rem;
    padding: 2.22rem 0 0 0;
  }

  .quality-module-description {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 0.3rem;
    color: #ffffff;
    line-height: 0.59rem;
    margin: 0.52rem 0 0 0;
  }

  .quality-demand-tags {
    display: flex;
    margin: 1.11rem 0 0 1.89rem;
  }

  .quality-tag {
    display: flex;
    align-items: center;
    padding: 0.2rem 0.3rem;
    background: rgba(255, 255, 255, 0.21);
    border-radius: 0.43rem;
    border: 0.02rem solid #ffffff;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 0.35rem;
    color: #ffffff;
    line-height: 0.37rem;
    margin: 0 0.15rem 0 0;

    flex-shrink: 0;
  }

  .goods-wrap {
    position: relative;
    overflow: hidden;
    margin: 1.11rem 0 0 0;
    padding-left: 1.89rem;
  }

  .goods-items {
    display: grid;
    grid-template-columns: repeat(10, 4.3rem);
    gap: 0.33rem;
    transition: transform 0.3s ease;
  }

  .goods-item {
    position: relative;
    width: 4.3rem;
    // height: 5.48rem;
    height: 6rem;
    background: #ffffff;
    border-radius: 0.15rem;
    // background-position: center;
    padding: 0 0 0 0.3rem;
    box-sizing: border-box;

    background-size: cover;
    // background-position: 0rem 0px;
  }

  .goods-item-image {
    position: absolute;
    right: -0.24rem;
    top: 0.22rem;
    width: 2.22rem;
    height: auto;
  }

  .demand {
    position: absolute;
    top: 1.65rem;
    display: flex;
    flex-wrap: wrap;
    width: 1.65rem;
  }

  .tag {
    padding: 0.04rem 0.07rem;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 0.15rem;
    color: #141414;
    background: #ebcdbb;
    border-radius: 0.21rem;
    margin: 0.06rem 0.06rem 0 0;
  }

  .goods-item-info {
    text-align: left;
  }

  .goods-name {
    font-family: SourceHanSansCN, SourceHanSansCN;
    font-weight: 800;
    font-size: 0.35rem;
    color: #141414;
    line-height: 0.37rem;
    margin: 2.94rem 0 0 0;
  }

  .goods-name-en {
    font-family: MADEEvolveSans;
    font-size: 0.2rem;
    color: #141414;
    line-height: 0.22rem;
    margin: 0.09rem;
  }

  .goods-point {
    margin: 0.24rem 0 0 0;
  }

  .goods-point-item {
    font-family: SourceHanSansCN, SourceHanSansCN;
    font-weight: 300;
    font-size: 0.18rem;
    color: #666666;
    line-height: 0.18rem;
    margin: 0 0 0.15rem 0;

    white-space: nowrap; /* 禁止文本换行 */
    overflow: hidden; /* 隐藏超出容器的内容 */
    text-overflow: ellipsis; /* 超出部分显示为省略号 */

    position: relative;

    padding-left: 0.13rem;
  }
  .goods-point-item:last-child {
    margin-bottom: 0;
  }
  .goods-point-item::before {
    content: "";
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 0.06rem;
    height: 0.06rem;
    border-radius: 50%;
    background: #999999;
  }

  .arrow-right {
    position: absolute;
    right: 1.18rem;
    top: 50%;
    transform: translateY(-50%);
    width: 1.19rem;
    height: 1.19rem;
    cursor: pointer;
    background-image: url("https://nutripacks-static.oss-cn-shenzhen.aliyuncs.com/static/official_website/index/arrow-right.png");
    background-size: cover;
    cursor: pointer;
    opacity: 0;
  }

  .arrow-right:hover {
    background-image: url("https://nutripacks-static.oss-cn-shenzhen.aliyuncs.com/static/official_website/index/arrow-right-2.png");
  }

  .arrow-left {
    position: absolute;
    left: 1.18rem;
    top: 50%;
    transform: translateY(-50%);
    width: 1.19rem;
    height: 1.19rem;
    cursor: pointer;
    background-image: url("https://nutripacks-static.oss-cn-shenzhen.aliyuncs.com/static/official_website/index/arrow-left.png");
    background-size: cover;
    cursor: pointer;
  }

  .arrow-left:hover {
    background-image: url("https://nutripacks-static.oss-cn-shenzhen.aliyuncs.com/static/official_website/index/arrow-left-2.png");
  }

  .promise {
    margin: 2.85rem 0 0 0;
  }

  .promise-wrap {
    width: 15.09rem;
    height: 11.15rem;

    background: rgba(255, 255, 255, 0.22);
    border-radius: 0 1.48rem 1.48rem 0;

    border-top: 0.02rem solid #ffffff;
    border-right: 0.02rem solid #ffffff;
    border-bottom: 0.02rem solid #ffffff;

    backdrop-filter: blur(15px);

    padding: 3.3rem 0 0 1.89rem;

    box-sizing: border-box;
    text-align: left;
  }

  .promise-conent {
    position: relative;
  }

  .promise-title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 0.81rem;
    color: #ffffff;
    line-height: 1.15rem;
  }

  .promise-description {
    width: 9.63rem;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 0.3rem;
    color: #ffffff;
    line-height: 0.59rem;
    margin: 0.52rem 0 0 0;
  }
  .promise-description_768 {
    display: none;
  }
  .promise-goods-img {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translate(50%, -50%);
    width: 3.31rem;
    height: auto;
  }

  .promise-tags-image {
    position: absolute;
    right: -8.29rem;
    top: 50%;
    transform: translateY(-50%);
    width: 5.22rem;
    height: 7.74rem;
  }

  .guarantee-module {
    display: flex;
    justify-content: center;
    // padding: 0 1.07rem 0 4.74rem;
    padding-left: 3.41rem;
    padding-bottom: 1.61rem;
  }

  .guarantee-left {
    margin: 2.96rem 0 0 0;
  }

  .guarantee-title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 0.81rem;
    color: #1a1a1a;
    line-height: 1.15rem;
  }

  .guarantee-items {
    margin: 1.44rem 0 0 0;
  }

  .guarantee-item {
    display: flex;
    justify-content: center;
    margin: 0 0 1.07rem 0;
  }

  .guarantee-item-icon {
    width: 1.26rem;
    height: 1.26rem;
  }

  .guarantee-item-right {
    text-align: left;

    margin: 0 0 0 0.28rem;
  }

  .guarantee-item-right-title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 0.37rem;
    color: #1a1a1a;
    line-height: 0.52rem;
  }

  .guarantee-item-right-description {
    width: 7.33rem;
    font-family: PingFangSC, PingFang SC;
    font-weight: 300;
    font-size: 0.26rem;
    color: #333333;
    line-height: 0.41rem;
  }

  .guarantee-right {
    width: 19.48rem;
    height: auto;
    margin: 0.65rem 0 0 0;
  }
  .dapeiExample_pc {
    background: #f6f4f1;
    padding-top: 2.2222rem;
    padding-bottom: 2.8889rem;
    .mainTitle {
      font-family: MADEEvolveSans, MADEEvolveSans;
      font-weight: bold;
      font-size: 0.8148rem;
      color: #141414;
      line-height: 1.1111rem;
      text-align: center;
      font-style: normal;
    }
    .subTitle {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 0.4074rem;
      color: #000000;
      line-height: 0.5556rem;
      text-align: center;
      font-style: normal;
      margin-top: 0.1852rem;
      margin-bottom: 1.6667rem;
    }
  }

  .red-icon {
    position: absolute;
    left: 0.76rem;
    bottom: 2.22rem;
    width: 2.67rem;
    height: 2.67rem;
    border-radius: 0.86rem 0 0.26rem 0;
  }

  .bottom {
  }

  .bottom-title {
    font-family: MADEEvolveSans;
    font-size: 0.41rem;
    color: #141414;
    line-height: 0.41rem;
    margin: 2.96rem 0 0 0;
  }

  .company-image {
    width: 21.17rem;
    // width: calc(100vw - 5.48rem);
    height: auto;
    margin: 1.48rem 0 0 0;
  }

  .bottom-banner-wrap {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 2.96rem 0 0 0;
    margin-bottom: 2.19rem;
  }

  .bottom-banner {
    width: 10.74rem;
    height: auto;
  }

  .bottom-banner-right {
    margin: 0 0 0 2.61rem;
  }

  .bottom-banner-title {
    font-family: MADEEvolveSans, MADEEvolveSans;
    font-weight: bold;
    font-size: 0.81rem;
    color: #141414;
    line-height: 1.11rem;
  }

  .bottom-banner-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 4.67rem;
    height: 1.11rem;
    background: #c25e4d;
    border-radius: 0.74rem;
    margin: 0.78rem 0 0 0;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 0.3rem;
    color: #ffffff;
    .arrR {
      width: 0.3rem;
      height: 0.2rem;
      margin-left: 0.19rem;
    }
  }

  .bottom-banner-btn:hover {
    background-color: #d35e4f;
  }
}
// 1920
@media screen and (min-width: 1920px) {
  .mobile {
    display: none;
  }
  .swpiperItem {
    .top {
      display: flex;
      justify-content: space-between;
      width: 100%;
      height: 11.89rem;
      // background: #f6f4f1;
      padding: 0 5.15rem 0 4.81rem;
      box-sizing: border-box;
    }

    .top-left {
      display: flex;
      flex-direction: column;
      justify-content: center;
      height: 100%;
      min-width: 6.6rem;
    }

    .top-left-one {
      font-family: MADEEvolveSans, MADEEvolveSans;
      font-weight: bold;
      font-size: 0.93rem;
      color: #1a1a1a;
      line-height: 1.09rem;
    }

    .top-left-one span {
      display: block;
      text-align: left;
    }

    .top-left-two {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 0.41rem;
      color: #1a1a1a;
      line-height: 0.56rem;
      margin: 0.5rem 0 0 0;
      text-align: left;
    }

    .top-left-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 3.15rem;
      height: 1.11rem;
      background: #c25e4d;
      border-radius: 0.74rem;
      margin: 1.11rem 0 0 0;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 0.33rem;
      color: #ffffff;
      line-height: 0.46rem;
    }

    .top-left-btn:hover {
      background-color: #d35e4f;
    }

    .top-right {
      position: relative;
      width: 14.72rem;
      height: 10.67rem;
    }

    .top-right-image {
      width: 14.72rem;
      height: 10.67rem;
    }
    .top-right2 {
      position: relative;
      width: 14.72rem;
      height: 100%;
      display: flex;
      align-items: center;
      .top-right-image {
        width: 14.72rem;
        height: 10.5rem;
      }
    }
    .top-right3 {
      position: relative;
      width: 14.72rem;
      height: 100%;
      display: flex;
      align-items: flex-end;
    }

    .top-right-text {
      position: absolute;
      left: 3.28rem;
      bottom: 0.54rem;
      font-family: PingFangSC, PingFang SC;
      font-weight: 100;
      font-size: 0.33rem;
      color: #1a1a1a;
      line-height: 0.46rem;
    }

    .top-right-text span {
      margin: 0 1.17rem 0 0;
    }
  }

  .step-module {
  }

  .step-module-title {
    font-family: MADEEvolveSans, MADEEvolveSans;
    font-weight: bold;
    font-size: 0.81rem;
    color: #1a1a1a;
    line-height: 0.96rem;
    margin: 2.22rem 0 0 0;
  }

  .step-module-title-ch {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 0.41rem;
    color: #333333;
    line-height: 0.56rem;
    margin: 0.19rem 0 0;
  }

  .stepItemBox {
    margin-left: 50%;
    transform: translateX(-50%);
    width: 25.9259rem;
    margin-top: 2.8148rem;
    display: flex;
    justify-content: space-between;
    .item {
      position: relative;
      width: 8.3704rem;
      height: 9.5185rem;
      border-radius: 0.1481rem;
      border: 0.0185rem solid #e5e5e5;
      box-sizing: border-box;
      padding: 0.3704rem 0.2963rem;
      .tag {
        position: absolute;
        top: -1.3333rem;
        left: 0;
        width: 1.7778rem;
        height: 0.6667rem;
        background: #ffffff;
        border-radius: 0.3333rem;
        border: 0.0185rem solid #000000;
        display: flex;
        justify-content: center;
        align-items: center;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 0.3333rem;
        color: #000000;
        line-height: 0.4444rem;
        text-align: left;
        font-style: normal;
      }
      .pic {
        width: 7.7778rem;
        height: 6.6667rem;
      }
      .pic_1440 {
        display: none;
      }
      .des1 {
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 0.3333rem;
        color: #141414;
        line-height: 0.4444rem;
        text-align: left;
        font-style: normal;
        margin-top: 0.5185rem;
      }
      .des2 {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 0.2593rem;
        color: #141414;
        line-height: 0.4444rem;
        text-align: left;
        font-style: normal;
        margin-top: 0.1481rem;
      }
    }
    .item:nth-child(2) {
      .tag {
        left: -0.8889rem;
      }
    }
    .item:nth-child(3) {
      .tag {
        left: -2.037rem;
      }
    }
  }
  .quality-module {
    // width: 35.56rem;
    width: 100%;
    // height: 42.11rem;
    background-image: url("https://nutripacks-static.oss-cn-shenzhen.aliyuncs.com/static/official_website/index/quality-bg.png");
    background-size: cover;
    background-position: center;
    margin: 2.22rem 0 0 0;
    padding-bottom: 2.98rem;
  }

  .quality-module-title {
    font-family: MADEEvolveSans, MADEEvolveSans;
    font-weight: bold;
    font-size: 0.81rem;
    color: #ffffff;
    line-height: 0.96rem;
    padding: 2.22rem 0 0 0;
  }

  .quality-module-description {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 0.3rem;
    color: #ffffff;
    line-height: 0.59rem;
    margin: 0.52rem 0 0 0;
  }

  .quality-demand-tags {
    display: flex;
    margin: 1.11rem 0 0 4.81rem;
  }

  .quality-tag {
    display: flex;
    align-items: center;
    padding: 0.22rem 0.42rem;
    background: rgba(255, 255, 255, 0.21);
    border-radius: 0.43rem;
    border: 0.02rem solid #ffffff;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 0.35rem;
    color: #ffffff;
    line-height: 0.37rem;
    margin: 0 0.15rem 0 0;

    flex-shrink: 0;
  }

  .goods-wrap {
    position: relative;
    overflow: hidden;
    margin: 1.11rem 0 0 0;
    padding-left: 4.81rem;
  }

  .goods-items {
    display: grid;
    grid-template-columns: repeat(10, 4.3rem);
    gap: 0.33rem;
    transition: transform 0.3s ease;
  }

  .goods-item {
    position: relative;
    width: 4.3rem;
    // height: 5.48rem;
    height: 6rem;
    background: #ffffff;
    border-radius: 0.15rem;
    // background-position: center;
    padding: 0 0 0 0.3rem;
    box-sizing: border-box;

    background-size: cover;
    // background-position: 0rem 0px;
  }

  .goods-item-image {
    position: absolute;
    right: -0.24rem;
    top: 0.22rem;
    width: 2.22rem;
    height: auto;
  }

  .demand {
    position: absolute;
    top: 1.65rem;
    display: flex;
    flex-wrap: wrap;
    width: 1.65rem;
  }

  .tag {
    padding: 0.04rem 0.07rem;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 0.15rem;
    color: #141414;
    background: #ebcdbb;
    border-radius: 0.21rem;
    margin: 0.06rem 0.06rem 0 0;
  }

  .goods-item-info {
    text-align: left;
  }

  .goods-name {
    font-family: SourceHanSansCN, SourceHanSansCN;
    font-weight: 800;
    font-size: 0.35rem;
    color: #141414;
    line-height: 0.37rem;
    margin: 2.94rem 0 0 0;
  }

  .goods-name-en {
    font-family: MADEEvolveSans;
    font-size: 0.2rem;
    color: #141414;
    line-height: 0.22rem;
    margin: 0.09rem;
  }

  .goods-point {
    margin: 0.24rem 0 0 0;
  }

  .goods-point-item {
    font-family: SourceHanSansCN, SourceHanSansCN;
    font-weight: 300;
    font-size: 0.18rem;
    color: #666666;
    line-height: 0.18rem;
    margin: 0 0 0.15rem 0;

    white-space: nowrap; /* 禁止文本换行 */
    overflow: hidden; /* 隐藏超出容器的内容 */
    text-overflow: ellipsis; /* 超出部分显示为省略号 */

    position: relative;

    padding-left: 0.13rem;
  }
  .goods-point-item:last-child {
    margin-bottom: 0;
  }
  .goods-point-item::before {
    content: "";
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 0.06rem;
    height: 0.06rem;
    border-radius: 50%;
    background: #999999;
  }

  .arrow-right {
    position: absolute;
    right: 1.18rem;
    top: 50%;
    transform: translateY(-50%);
    width: 1.19rem;
    height: 1.19rem;
    cursor: pointer;
    background-image: url("https://nutripacks-static.oss-cn-shenzhen.aliyuncs.com/static/official_website/index/arrow-right.png");
    background-size: cover;
    cursor: pointer;
    opacity: 0;
  }

  .arrow-right:hover {
    background-image: url("https://nutripacks-static.oss-cn-shenzhen.aliyuncs.com/static/official_website/index/arrow-right-2.png");
  }

  .arrow-left {
    position: absolute;
    left: 1.18rem;
    top: 50%;
    transform: translateY(-50%);
    width: 1.19rem;
    height: 1.19rem;
    cursor: pointer;
    background-image: url("https://nutripacks-static.oss-cn-shenzhen.aliyuncs.com/static/official_website/index/arrow-left.png");
    background-size: cover;
    cursor: pointer;
  }

  .arrow-left:hover {
    background-image: url("https://nutripacks-static.oss-cn-shenzhen.aliyuncs.com/static/official_website/index/arrow-left-2.png");
  }

  .promise {
    margin: 2.96rem 0 0 0;
  }

  .promise-wrap {
    width: 19.54rem;
    height: 11.15rem;
    background: rgba(255, 255, 255, 0.22);
    border-radius: 0 1.48rem 1.48rem 0;
    border-top: 0.02rem solid #ffffff;
    border-right: 0.02rem solid #ffffff;
    border-bottom: 0.02rem solid #ffffff;

    backdrop-filter: blur(15px);
    padding: 3.54rem 0 0 4.81rem;
    box-sizing: border-box;
    text-align: left;
  }

  .promise-conent {
    position: relative;
  }

  .promise-title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 0.81rem;
    color: #ffffff;
    line-height: 1.15rem;
  }

  .promise-description {
    width: 9.63rem;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 0.3rem;
    color: #ffffff;
    line-height: 0.59rem;
    margin: 0.52rem 0 0 0;
  }
  .promise-description_768 {
    display: none;
  }
  .promise-goods-img {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translate(50%, -50%);
    width: 3.31rem;
    height: auto;
  }

  .promise-tags-image {
    position: absolute;
    right: -8.29rem;
    top: 50%;
    transform: translateY(-50%);
    width: 5.22rem;
    height: 7.74rem;
  }

  .guarantee-module {
    display: flex;
    justify-content: center;
    // padding: 0 1.07rem 0 4.74rem;
    padding-left: 4.81rem;
  }

  .guarantee-left {
    margin: 2.98rem 0 0 0;
  }

  .guarantee-title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 0.81rem;
    color: #1a1a1a;
    line-height: 1.15rem;
  }

  .guarantee-items {
    margin: 1.44rem 0 0 0;
  }

  .guarantee-item {
    display: flex;
    justify-content: center;
    margin: 0 0 1.07rem 0;
  }

  .guarantee-item-icon {
    width: 1.26rem;
    height: 1.26rem;
  }

  .guarantee-item-right {
    text-align: left;

    margin: 0 0 0 0.28rem;
  }

  .guarantee-item-right-title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 0.37rem;
    color: #1a1a1a;
    line-height: 0.52rem;
  }

  .guarantee-item-right-description {
    width: 7.33rem;
    font-family: PingFangSC, PingFang SC;
    font-weight: 300;
    font-size: 0.26rem;
    color: #333333;
    line-height: 0.41rem;
  }

  .guarantee-right {
    width: 19.48rem;
    height: auto;
    margin: 0.65rem 0 0 0;
  }
  .dapeiExample_pc {
    background: #f6f4f1;
    padding-top: 2.2222rem;
    padding-bottom: 2.8889rem;
    .mainTitle {
      font-family: MADEEvolveSans, MADEEvolveSans;
      font-weight: bold;
      font-size: 0.8148rem;
      color: #141414;
      line-height: 1.1111rem;
      text-align: center;
      font-style: normal;
    }
    .subTitle {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 0.4074rem;
      color: #000000;
      line-height: 0.5556rem;
      text-align: center;
      font-style: normal;
      margin-top: 0.1852rem;
      margin-bottom: 1.6667rem;
    }
  }

  .red-icon {
    position: absolute;
    left: 3.5rem;
    bottom: 2.22rem;
    width: 2.67rem;
    height: 2.67rem;
    border-radius: 0.86rem 0 0.26rem 0;
  }

  .bottom {
  }

  .bottom-title {
    font-family: MADEEvolveSans;
    font-size: 0.41rem;
    color: #141414;
    line-height: 0.41rem;
    margin: 2.96rem 0 0 0;
  }

  .company-image {
    width: 21.17rem;
    // width: calc(100vw - 5.48rem);

    height: auto;
    margin: 1.48rem 0 0 0;
  }

  .bottom-banner-wrap {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 2.96rem 0 0 0;
    margin-bottom: 2.4444rem;
  }

  .bottom-banner {
    width: 12.26rem;
    height: auto;
  }

  .bottom-banner-right {
    margin: 0 0 0 2.61rem;
  }

  .bottom-banner-title {
    font-family: MADEEvolveSans, MADEEvolveSans;
    font-weight: bold;
    font-size: 0.81rem;
    color: #141414;
    line-height: 1.11rem;
  }

  .bottom-banner-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 4.67rem;
    height: 1.11rem;
    background: #c25e4d;
    border-radius: 0.74rem;
    margin: 0.78rem 0 0 0;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 0.3rem;
    color: #ffffff;
    .arrR {
      width: 0.3rem;
      height: 0.2rem;
      margin-left: 0.19rem;
    }
  }

  .bottom-banner-btn:hover {
    background-color: #d35e4f;
  }
}
</style>
